<template>
  <svg
    v-if="icon === 'map-center'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25.941 25.941"
    style="enable-background: new 0 0 25.941 25.941"
    xml:space="preserve"
  >
    <g>
      <path
        d="M10.632,11.049l-6.527-0.617c0,0-0.869,0.023-0.385-0.461c0.488-0.486,1.664-1.664,1.664-1.664S5.097,8.021,4.66,7.58
		C3.404,6.324,1.119,4.039,0.189,3.109c0,0-0.322-0.188,0.064-0.57C0.638,2.15,2.32,0.467,2.595,0.195
		C2.866-0.08,3.074,0.142,3.074,0.142c0.904,0.9,3.27,3.264,4.482,4.479c0.395,0.394,0.652,0.652,0.652,0.652
		s0.943-0.945,1.539-1.539c0.592-0.592,0.588,0.301,0.588,0.301s0.826,5.848,0.826,6.547C11.162,11.092,10.632,11.049,10.632,11.049
		z"
      />
      <path
        d="M15.371,14.904l6.525,0.617c0,0,0.871-0.025,0.387,0.459c-0.486,0.486-1.666,1.67-1.666,1.67s0.285,0.281,0.727,0.723
		c1.258,1.256,3.541,3.541,4.473,4.475c0,0,0.318,0.182-0.064,0.564c-0.385,0.387-2.07,2.074-2.348,2.348
		c-0.27,0.271-0.475,0.055-0.475,0.055c-0.904-0.906-3.27-3.268-4.484-4.482c-0.393-0.393-0.646-0.648-0.646-0.648
		s-0.945,0.941-1.543,1.535c-0.592,0.594-0.592-0.299-0.592-0.299s-0.82-5.852-0.82-6.547
		C14.843,14.863,15.371,14.904,15.371,14.904z"
      />
      <path
        d="M10.994,15.338l-0.615,6.529c0,0,0.025,0.873-0.461,0.385c-0.488-0.49-1.668-1.666-1.668-1.666s-0.287,0.287-0.721,0.727
		c-1.258,1.258-3.547,3.541-4.477,4.475c0,0-0.186,0.314-0.57-0.068s-2.066-2.072-2.344-2.34c-0.275-0.273-0.055-0.482-0.055-0.482
		c0.904-0.9,3.266-3.268,4.482-4.482c0.395-0.393,0.652-0.65,0.652-0.65s-0.943-0.945-1.539-1.535
		c-0.596-0.596,0.297-0.592,0.297-0.592s5.852-0.822,6.553-0.822C11.037,14.814,10.994,15.338,10.994,15.338z"
      />
      <path
        d="M14.849,10.601l0.615-6.531c0,0-0.023-0.867,0.461-0.383c0.488,0.488,1.666,1.668,1.666,1.668s0.287-0.287,0.729-0.727
		c1.256-1.258,3.539-3.541,4.471-4.471c0,0,0.186-0.32,0.57,0.066c0.385,0.381,2.068,2.066,2.342,2.338
		c0.277,0.275,0.057,0.482,0.057,0.482c-0.902,0.904-3.268,3.268-4.48,4.482c-0.396,0.391-0.656,0.648-0.656,0.648
		s0.947,0.943,1.541,1.537c0.592,0.598-0.297,0.592-0.297,0.592s-5.852,0.824-6.553,0.824
		C14.808,11.129,14.849,10.601,14.849,10.601z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<script>
export default {
  name: 'IconsMap',
  props: {
    icon: String,
  },
}
</script>

<style scoped></style>
